


import { Col, Input, Row, Table, Switch, Popconfirm, Button, notification, Spin } from "antd";
import { useEffect, useState } from "react";
import { setHeaderName } from "../../../../../services/SetHeaderName";
import { EditOutlined, DeleteOutlined, PlusOutlined, UpSquareOutlined, DownSquareOutlined } from '@ant-design/icons';
// import { setHeaderName } from "../../../../services/SetHeaderName";
import '../style/PhenoTypeQuestions.scss'
import { AddPhenotypeQuestions } from "./AddPhenotypeQuestions";
import { listOfPhenotypeQuestionApi, updatePhenotypeQuestionApi } from "../../../../../config/Api";
import { API_ERR_MESSAGE } from "../../../../../config/constant";

export const PhenotypeQuestions = () => {

    const data = [
        {
            id: '1001',
            domain: 'Lifestyle',
            question: 'How do you see your lifestyle?',
            kapha: 'It is often changing (Erratic) and I don’t feel pressured with responsibilities',
            pitta: 'It is normally well planned or I prefer working in planned way',
            vata: 'I feel its regular and easy going for me',
            active: true,
        },
        {
            id: '1002',
            domain: 'Activity',
            question: 'How is your activity level? How much you like sitting or you feel lively most of the time and feel restless when sitting?',
            kapha: 'I love moving around or like movement throughout the day. While sitting I feel restless',
            pitta: 'I feel energetic and active throughout the day, enjoy exercise and I also enjoy competition',
            vata: 'I like being sitting and working most of the time. I take time to finish my tasks',
            active: false,
        },
        {
            id: '1003',
            domain: 'Body Frame',
            question: 'How does your body frame/ body type/ frame size, look like?',
            kapha: 'Usually thin and I am underweight',
            pitta: 'I am medium built and have some weight issues',
            vata: 'I am broad and weight is on heavy side',
            active: false,
        },
    ];
    const [dataSource, setDataSource] = useState([]);
    const [displayData, setDisplayData] = useState([]);
    const [questionData, setquestionData] = useState();
    const [isActive, setIsActive] = useState(false)
    const [updateQuestionList, setUpdateQuestionList] = useState(false);

    const [editQuestion, setEditQuestion] = useState(false)
    const [editQuestionData, setEditQuestionData] = useState()
    const [loading, setLoading] = useState(false)

    const getListOfPhenotypeQuestion = () => {
        setLoading(true)

        listOfPhenotypeQuestionApi()
            .then((res) => {
                if (res.status === 200) {
                    setDataSource(res.data.data);
                    setDisplayData(res.data.data);
                }
                setLoading(false)
            })
            .catch((err) => {
                notification.error({
                    message: 'something went wrong',
                });
            });
    }

    useEffect(() => {
        getListOfPhenotypeQuestion()
        setHeaderName("PhenotypeQuestions")
    }, [updateQuestionList]);
    // useEffect(() => {
    //     <AddPhenotypeQuestions
    //         updateQuestionList={updateQuestionList}
    //         setUpdateQuestionList={setUpdateQuestionList}
    //         editQuestion={editQuestion}
    //         setEditQuestion={setEditQuestion}
    //         editQuestionData={editQuestionData}
    //     />
    // }, [editQuestionData]);

    // update status of recipe category
    const onChange = (checked, data) => {
        let updatedData = data;
        updatedData.status = checked;
        const updatedObject = {
            "question_domain_id": data.id,
            "question": data.question,
            "kapha": data.kapha,
            "pitta": data.pitta,
            "vata": data.vata,
            "status": checked
        }
        updatePhenotypeQuestionApi(data.id, updatedObject)
            .then((res) => {
                if (res.status == 200) {
                    notification.success({
                        message: "Question Update successfully",
                    });
                    setUpdateQuestionList(!updateQuestionList)
                }
            })
            .catch((err) => {
                notification.error({
                    message: API_ERR_MESSAGE,
                });
            });
    };

    const editPhenoTypeQuestion = (record) => {
        setEditQuestionData(record);
        setEditQuestion(true);
    }
    useEffect(() => {
        <AddPhenotypeQuestions
            updateQuestionList={updateQuestionList}
            setUpdateQuestionList={setUpdateQuestionList}
            editQuestion={editQuestion}
            setEditQuestion={setEditQuestion}
            editQuestionData={editQuestionData}
        />
    }, [editQuestionData, editQuestion])

    const columns = [
        // {
        //     title: 'ID',
        //     dataIndex: 'id',
        //     key: 'name',
        //     defaultSortOrder: 'ascend',
        //     sorter: (a, b) => a.id - b.id,
        //     // render: (text) => <a>{text}</a>,
        // },
        {
            title: 'Domain',
            dataIndex: 'question_domain',
            key: 'question_domain.domain',
            render: (record) => <p>{record ? record.domain : ''}</p>,
        },
        {
            title: 'Question',
            dataIndex: 'question',
            key: 'question',
        },
        // {
        //     title: 'Kapha',
        //     dataIndex: 'kapha',
        //     key: 'kapha',
        // },
        // {
        //     title: 'Pitta',
        //     dataIndex: 'pitta',
        //     key: 'pitta',
        // },
        // {
        //     title: 'Vata',
        //     dataIndex: 'vata',
        //     key: 'vata',
        // },
        {
            title: 'Status',
            dataIndex: 'status',
            key: 'status',
            render: (text, data) => <>
                <Switch checked={text} onChange={(e) => { setIsActive(!isActive); onChange(e, data) }} />
            </>,
            filters: [
                { text: "Active", value: true },
                { text: "Deactive", value: false },
            ],
            onFilter: (value, record) => record.status == value,
        },
        {
            title: 'Action',
            key: 'action',
            render: (_, record) => (
                <div className="action align-self-center">
                    <Button icon={<EditOutlined />} className="me-2" onClick={() => editPhenoTypeQuestion(record)} />
                    <Popconfirm title="Sure to delete?" >
                        <Button icon={<DeleteOutlined />} className="me-2" />
                    </Popconfirm>
                </div>
            ),
        },
    ];

    const expandedRowRender = (record) => {
        const innercolumns = [
            {
                title: 'Kapha',
                dataIndex: 'kapha',
            },
            {
                title: 'Pitta',
                dataIndex: 'pitta',
            },
            {
                title: 'Vata',
                dataIndex: 'vata',
            },
        ]
        return (
            <Table
                columns={innercolumns}
                dataSource={[record]}
                pagination={false}
            />
        )
    };

    // filter question list on user search input
    const filterQuestions = (data) => {
        if (!data) {
            setDisplayData(dataSource);
        } else {
            let tmp = [];
            dataSource.length > 0 && dataSource.forEach((element) => {
                if (element.question.toUpperCase().indexOf(data.toUpperCase()) !== -1 ||
                    element.question_domain.domain.toUpperCase().indexOf(data.toUpperCase()) !== -1 ||
                    element.kapha.toUpperCase().indexOf(data.toUpperCase()) !== -1 ||
                    element.pitta.toUpperCase().indexOf(data.toUpperCase()) !== -1 ||
                    element.vata.toUpperCase().indexOf(data.toUpperCase()) !== -1
                ) {
                    tmp.push(element);
                }
            });
            setDisplayData(tmp);
        }
    };
    return (
        <>
            <AddPhenotypeQuestions
                updateQuestionList={updateQuestionList}
                setUpdateQuestionList={setUpdateQuestionList}
                editQuestion={editQuestion}
                setEditQuestion={setEditQuestion}
                editQuestionData={editQuestionData}
            />
            <div className="PhenotypeQuestions">
                <Row className="mb-2">
                    <Col md={4} xl={6} xxl={4} className="align-self-center">
                        <h4 className="ms-2 mb-0">Questions List</h4>
                    </Col>
                    <Col md={8} xl={12} className="text-end align-self-center pe-4">
                        <h6 className="mb-0">Total Questions:  {displayData.length > 0 ? displayData.length : 0} </h6>
                    </Col>
                    <Col md={12} xl={6} className="align-self-center pe-2">
                        <Input.Search placeholder="Search Question" onChange={e => { filterQuestions(e.target.value); setquestionData(e.target.value) }
                        }

                            // let filteredData = dataSource.length > 0 && dataSource.filter(entry =>
                            //     entry.question.toLowerCase().includes(currValue.toLowerCase()) ||
                            //     entry.question_domain.domain.toLowerCase().includes(currValue.toLowerCase()) ||
                            //     entry.kapha.toLowerCase().includes(currValue.toLowerCase()) ||
                            //     entry.pitta.toLowerCase().includes(currValue.toLowerCase()) ||
                            //     entry.vata.toLowerCase().includes(currValue.toLowerCase())
                            // )
                            // setDataSource(filteredData);
                            // }
                            className="p-2" />
                    </Col>
                </Row>
                <Spin spinning={loading} className="spinner-code">
                    <Row>
                        <Table
                            columns={columns}
                            dataSource={displayData}
                            // pagination={false}
                            rowKey="id"
                            scroll={{ x: "max-content" }}
                            className="w-100"

                            expandIcon={({ expanded, onExpand, record }) =>
                                expanded ? (
                                    <UpSquareOutlined onClick={(e) => onExpand(record, e)} />
                                ) : (
                                    <DownSquareOutlined onClick={(e) => onExpand(record, e)} />
                                )
                            }
                            expandable={{
                                expandedRowRender: ((record) => expandedRowRender(record)),
                                // expandIconColumnIndex: 10,
                                // rowExpandable: (record) => console.log(record),
                                rowExpandable: (record) => record.id !== 'Not Expandable'
                            }}
                        />
                    </Row>
                </Spin>
            </div>
        </>
    )
}
